import React from 'react';
import { Label, ReferenceDot, ReferenceLine } from 'recharts';

import { getMessage } from 'util/locale';
import { formatNumberK } from 'util/formatters/numberFormatter';
import COLORS from 'constants/colors';

const NewPlanLabel = ({ cx, cy }: { cx: number; cy: number }) => {
  const width = 76;
  return (
    <g>
      <rect
        x={cx - 38}
        y={cy - 30}
        width={`${width}px`}
        height='16'
        rx='8'
        fill={COLORS.scenarios.newPlan}
      />
      <text x={cx - 38} y={cy - 18} style={{
        fontSize: '12px',
        fill: 'white',
        transform: `translate(${width/2}px)`,
        textAnchor: 'middle'
      }}> 
        {getMessage('new-plan')}
      </text>
    </g>
  );
};

const NewPlanBaseReferences = ({
  plantingRate,
  estimatedYield,
  minYield
}: {
  plantingRate: number;
  estimatedYield: number;
  minYield: number;
}) => {
  return (
    <React.Fragment>
      <ReferenceDot
        r={5}
        x={plantingRate}
        y={estimatedYield}
        fill={COLORS.scenarios.newPlan}
        stroke={COLORS.scenarios.newPlan}
      />
      {/* Point of the new plan in the curve. */}
      <ReferenceDot x={plantingRate} y={estimatedYield} shape={NewPlanLabel} />
      {/* Line that points to the new plan starting at the x axis */}
      <ReferenceLine
        ifOverflow='hidden'
        strokeOpacity={0.3}
        strokeDasharray='3 3'
        stroke={COLORS.scenarios.newPlan}
        segment={[
          { x: plantingRate, y: 2 },
          { x: plantingRate, y: estimatedYield }
        ]}
      />
      {/* Point the x axis that shows where the new plan is, */}
      <ReferenceDot
        ifOverflow='hidden'
        r={0}
        x={plantingRate}
        y={minYield}
        fill={COLORS.scenarios.newPlan}
        stroke={COLORS.scenarios.newPlan}
      >
        {/* This is the value of the rate of the new plan that appears bellow. */}
        <Label value={formatNumberK(plantingRate)} position='top' offset={10} fill={COLORS.scenarios.newPlan} />
      </ReferenceDot>
    </React.Fragment>
  );
};

export default NewPlanBaseReferences;
